import { Button, Card, Typography, message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { pickSiteUrl, toPublicHost, visibleInstanceUrls } from "../core/site-domain";
import { serverFetch } from "../core/server";
import "./cabinet-page.css";

const STATUS_LABEL = {
  notInstalled: "Не установлено",
  mock: "Создано (мок, Windows)",
  running: "Работает",
  stopped: "Остановлено",
  error: "Ошибка"
};

const DefaultAppPage = () => {
  const [app, setApp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    serverFetch("app/default")
      .then(setApp)
      .catch((e) => message.error(e.userMessage || e.message || "Не удалось загрузить базу по умолчанию"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const onCreate = () => {
    setCreating(true);
    serverFetch("app/default", { method: "POST" })
      .then((data) => {
        message.success(data.mock ? "Копия создана (мок на Windows)" : "База по умолчанию запущена");
        setApp(data);
      })
      .catch((e) => message.error(e.userMessage || e.message || "Не удалось создать базу по умолчанию"))
      .finally(() => setCreating(false));
  };

  const ready = app && app.status !== "notInstalled";
  const appUrl =
    pickSiteUrl(
      visibleInstanceUrls(app?.urls?.length ? app.urls : app?.url ? [app.url] : []),
      toPublicHost(app?.url)
    ) || "https://default.webokna.online";

  return (
    <div className="cabinet">
      <Typography.Title level={2}>База по умолчанию</Typography.Title>
      <Typography.Paragraph type="secondary">
        Зарезервированная копия <strong>default.webokna.online</strong>. Справочники и настройки
        правятся в обычной ВЕБ Окна. Новые компании получают копию этой базы.
      </Typography.Paragraph>

      <Card className="cabinet-card" title="Копия" loading={loading}>
        <Typography.Paragraph className="cabinet-status">
          Статус: <strong>{STATUS_LABEL[app?.status] || "—"}</strong>
        </Typography.Paragraph>
        <Typography.Paragraph>
          Адрес:{" "}
          {ready ? (
            <a href={appUrl} target="_blank" rel="noreferrer">
              {appUrl}
            </a>
          ) : (
            <strong>https://default.webokna.online</strong>
          )}
        </Typography.Paragraph>
        {ready ? (
          <Button type="primary" href={appUrl} target="_blank" rel="noreferrer">
            Открыть ВЕБ Окна
          </Button>
        ) : (
          <Button type="primary" onClick={onCreate} loading={creating}>
            Создать
          </Button>
        )}
      </Card>
    </div>
  );
};

export default DefaultAppPage;
